import { Component, OnInit } from '@angular/core';
import { CacService } from 'src/app/services/cac.service';
import { MessageService } from 'primeng/api';
import { CacModel } from 'src/app/models/cac.model';
import { GiftCardNCRModel } from 'src/app/models/gifcardVirtual.model';

@Component({
  selector: 'app-cac-consult',
  templateUrl: './cac-consult.component.html',
  styleUrls: ['./cac-consult.component.css']
})
export class CacConsultComponent implements OnInit {

  itemGiftCard;
  datasourceGiftCard;
  datasourceGiftCardNCR;
  loading: boolean = false;
  secuencia: number;

  constructor(private cacService: CacService,
      private messageService: MessageService) { }

  ngOnInit() {
    this.itemGiftCard = null;
  }

  searchGiftCardVirtual(){
    this.loading = true;
    if (this.secuencia){
      let params = {
        "p_id_secuence_ncr" : this.secuencia
      }
      this.cacService.GetGiftCardBySecuence(params).subscribe(
        ((response: CacModel[]) => {
          this.datasourceGiftCard = response;
          if (this.datasourceGiftCard){
            
            this.itemGiftCard = this.datasourceGiftCard[0];
            this.searchGiftCardNCRByBin(this.itemGiftCard.BIN_GIFT_CARD);
          }
        }),
        (error => {
          this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrío un problema al consultar giftcard.'});
        })
      )
    }
    else{
      this.messageService.add({severity:'error', summary: 'Error', detail:'Ingrese un número de secuencial válido.'});
    }
  }

  searchGiftCardNCRByBin(bin: number){
    let params = {
      "p_bin_giftcard" : bin
    }

    this.cacService.GetGiftCardByNumber(params).subscribe(
      ((response : GiftCardNCRModel[]) =>{
        this.datasourceGiftCardNCR = response;
        this.itemGiftCard.SALDO_GIFT_CARD = this.datasourceGiftCardNCR[0].netAmount;
        this.loading = false;
      }),
      (error => {
        this.messageService.add({severity:'error', summary: 'Error', detail:'Ocurrío un problema al consultar giftcard NCR.'});
      })
    )

  }

}
